import { Injectable } from '@angular/core';
import { CommonHttpService } from './http.service';
import { Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class StoreConfigurationsService {
    private dataLoadingSource: Subject<any> = new Subject();
    private dataLoadedSource: Subject<any> = new Subject();
    public configurations: Array<any> = [];
    public dataLoading$ = this.dataLoadingSource.asObservable();
    public dataLoaded$ = this.dataLoadedSource.asObservable();

    constructor(
        protected http: CommonHttpService
    ) {
        this.init();
    }

    /**
     * This instances new Subjects and observables.
     **/
    private init() {
        this.dataLoadingSource = new Subject();
        this.dataLoadedSource = new Subject();
        this.dataLoading$ = this.dataLoadingSource.asObservable();
        this.dataLoaded$ = this.dataLoadedSource.asObservable();
    }

    /**
     * Call GET request to resolve data load.
     **/
    public dataLoad() {
        this.dataLoadingSource.next(null);
        this.dataLoadingSource.complete();

        this.http
            .get('/_data?scope=store-configurations')
            .subscribe((response: Response) => {
                const configurations = response.json().data['store-configurations'];

                this.dataLoadedSource.next(configurations);
                this.dataLoadedSource.complete();

                this.init();
            });
    }

    /**
     * Compare values with configuration by informed key.
     **/
    public is(key: string, value: any): boolean {
        if (this.has(key)) {
            return this.get(key) === value;
        }

        return false;
    }

    /**
     * Find configuration at object by key.
     **/
    public get(key: string, def = null): any {
        if (!this.has(key)) {
            return def;
        }

        return this.configurations.filter((config) => {
            return config.key === key;
        })[0];
    }

    /**
     * Find configuration at object by key.
     **/
    public has(key: string): any {
        return this.configurations.filter((config) => {
            return config.key === key;
        }).length > 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/services/store-configurations.service.ts